import Auth from "./api/AuthAPI";
import User from "./api/UserAPI";
import Common from "./api/CommonAPI";
import Organization from "./api/OrganizationAPI";
import MedicalTool from "./api/MedicalToolAPI";
import SpecGroup from "./api/SpecGroupAPI";
import Report from "./api/ReportAPI";

export default {
   Auth,
  User,
  Common,
  Organization,
  MedicalTool,
  SpecGroup,
  Report,
}
